module.exports = __webpack_public_path__ + "img/全景智联机场智慧运营管理平台.05f15d49.jpg";